import httpClient from '@/apis/base/httpclient';
import BaseAPI from '@/apis/base/baseApi';
import { MSEnum } from '@/commons/enumeration'
class UserAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "TaskGo";
  controllerName = 'Tasks';
  /**
   * Lấy số lượng công việc cho các tab (hiển thị tại left menu)
   * @author: BMThang(07/02/2023)
   */
  getTaskCount() {
    let request = {
      url: `${this.getAPIUrl()}/TaskCount`,
    };
    return httpClient.getAsync(request);
  }
  /**
   * Lay nhung cong viec co the ban giao
   * vdhuy 28/3/23
   */
  getHandoverTask(payload) {
    let request = {
      url: `${this.getAPIUrl()}/GetHandoverTask`,
      data: payload,
      transformResponse: (res) => {
        return res;
      },
    }
    return httpClient.postAsync(request);
  }
  /**
   * Lưu công việc
   * @param {object} taskData Dữ liệu task
   * @author: BMThang(13/12/2022)
   */
  saveTask(taskData) {
    let request = {
      url: `${this.getAPIUrl()}/SaveTask`,
      data: taskData,
      transformResponse: (res) => {
        return res;
      },
    };
    return httpClient.postAsync(request);
  }
  /***
   * Lấy danh sách tất cả công việc
   */
  getTaskListPaging(param) {
    //  
    let request = {
      url: `${this.getAPIUrl()}/GetPaging`,
      data: param,
      transformResponse: (res) => {
        return res;
      },
    };
    return httpClient.postAsync(request);
  }
  /**
   * Lấy danh sách công việc ở các tab phức tạp
   */
  getTaskListPagingByMode(param) {
    let request = {
      url: `${this.getAPIUrl()}/GetTaskPagingByMode`,
      data: param,
      transformResponse: (res) => {
        return res;
      },
    };
    return httpClient.postAsync(request);
  }

  /***
   * Lấy danh sách tất cả công việc
   */
  getTaskListPagingChildren(param) {
    let request = {
      url: `${this.getAPIUrl()}/list`,
      data: param,
      transformResponse: (res) => {
        return res;
      },
    };
    return httpClient.postAsync(request);
  }
  /***
   * Lấy danh sách tất cả công việc con o cac tab ngoai tab tat car
   */
  getTaskListPagingChildrenByMode(param, mode) {
    let request = {
      url: `${this.getAPIUrl()}/GetChildByMode?mode=${mode}`,
      data: param,
      transformResponse: (res) => {
        return res;
      },
    };
    return httpClient.postAsync(request);
  }
  /***
   * Lấy danh sách tất cả công việc
   */
  getTaskListPagingNew(param, mode) {
    let request = {
      url: `${this.getAPIUrl()}/GetTaskPaging?mode=${mode}`,
      data: param,
      transformResponse: (res) => {
        return res;
      },
    };
    return httpClient.postAsync(request);
  }
  /**
   * Chỉnh sửa dữ liệu nhiều bản ghi tiến độ công việc
   */
  submitProcessTask(param) {
    let request = {
      url: `${this.getAPIUrl()}/SubmitProcess`,
      data: Array.isArray(param) ? [...param] : [param],
    };
    return httpClient.postAsync(request);
  }

  /**
   * Chỉnh sửa dữ liệu nhiều bản ghi công việc
   */
  cancelDoneTask(param) {
    let request = {
      url: `${this.getAPIUrl()}/CancelDoneTask`,
      data: param,
      transformResponse: (res) => {
        return res;
      },
    };
    return httpClient.postAsync(request);
  }

  /**
   * Chỉnh sửa dữ liệu nhiều bản ghi tỉ trọng công việc
   */
  submitProportionTask(param) {
    let request = {
      url: `${this.getAPIUrl()}/SubmitProportion`,
      data: [param],
      transformResponse: (res) => {
        return res;
      },
    };
    return httpClient.postAsync(request);
  }
  /**
   * Chỉnh sửa dữ liệu nhiều bản ghi công việc
   */
  submitHandoverTask(param) {
    let request = {
      url: `${this.getAPIUrl()}/HandoverTask`,
      data: [...param],
      transformResponse: (res) => {
        return res;
      },
    };
    return httpClient.postAsync(request);
  }
  /**
   * Lấy công việc dựa vào ID
   * @param {string} taskID id task
   * @author: BMThang(23/12/2022)
   */
  getTaskByID(taskID) {
    let request = {
      url: `${this.getAPIUrl()}/GetTask/${taskID}`,
      transformResponse: (res) => {
        return res;
      },
    };
    return httpClient.getAsync(request);
  }

  /**
   * Xóa công việc dựa vào ID
   * @param {string} taskID id task
   * @author: BMThang(28/12/2022)
   */
  deleteTaskByTaskID(taskID) {
    let request = {
      url: `${this.getAPIUrl()}/DeleteTaskByTaskID/${taskID}`
    };

    return httpClient.deleteAsync(request);
  }

  /**
   * Cập nhật file kết quả công việc dựa vào ID
   * @param {string} taskID id task
   * @param {array} attachmentResults danh sách file kết quả công việc
   * @param {number} editVersion editVersion
   * @author: BMThang(03/01/2022)
   */
  updateAttachmentResults(taskID, attachmentResults, editVersion) {
    let request = {
      url: `${this.getAPIUrl()}/UpdateAttachmentResults/${taskID}`,
      data: {
        AttachmentResults: attachmentResults,
        EditVersion: editVersion
      },
      notAllowProcessSubmitData: true,
      transformResponse: (res) => {
        return res;
      }
    };
    return httpClient.putAsync(request);
  }

  /**
   * Lấy bản ghi mặc định khi thêm mới
   * @param {string} taskID ID Công việc
   * @param {boolean} isPreventParsse Có chặn parse ko
   * @author: BMThang(16/01/2023)
   */
  getEdit(taskID, isPreventParsse = false) {
    let request = {
      url: `${this.getAPIUrl()}/edit/${taskID}`,
    };
    if (isPreventParsse === true) {
      request.transformResponse = (res) => {
        return res;
      }

    }
    return httpClient.getAsync(request);
  }

  /**
   * Kiểm tra công việc có bị quá hạn (ko hoàn thành ko)
   * @param {string} taskID ID Công việc
   * @author: BMThang(30/01/2023)
   */
  isNotDone(taskID) {
    let request = {
      url: `${this.getAPIUrl()}/IsNotDone/${taskID}`,
    };
    return httpClient.getAsync(request);
  }

  /**
   * Cập nhật nhắc việc
   * @author: nqloi(22/2/2023)
   */
  updateReminder(taskID, reminder) {
    let request = {
      url: `${this.getAPIUrl()}/UpdateReminder/${taskID}`,
      data: reminder,
      transformResponse: (res) => {
        return res;
      },
    };
    return httpClient.postAsync(request);
  }
  
  /**
   * Đồng bộ công việc từ bộ
   */
  syncTasks() {
    let request = {
      url: `${this.getAPIUrl()}/SyncTasks`,
      transformResponse: (res) => {
        return res;
      },
    };
    return httpClient.postAsync(request);
  }
  
  /**
   * Cập nhật  nhiệm vụ
   */
  updateMission(param) {
    let request = {
      url: `${this.getAPIUrl()}/UpdateMission`,
      data: param,
      transformResponse: (res) => {
        return res;
      },
    };
    return httpClient.postAsync(request);
  }
}

export default new UserAPI();
